/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import useForm from "../../../hooks/useForm";
import { requestCompany } from "../../../apis/companies/companies";
import Button from "../../../components/Button";
import { COMPANY_TYPE } from "../../../constants/COMPANY";
import systemAlert from "../../../utils/systemAlert";
import { useHistory } from "react-router";
import { cleanObj } from "../../../utils/cleanObj";
import { getReferrer, getThroughTaxCompanyCode } from "../../../utils/storage";
import ToolTip from "../../../components/ToolTip/ToolTip";
import { viewLoading } from "../../../utils/loading";

const RequestCreateCompany = () => {
  const history = useHistory();

  const submit = (values) => {
    cleanObj(values);

    // if(values.type === "1" && (isEmpty(values.taxCompanyCode) || (values.taxCompanyCode.length !== 6)) ) {
    //   systemAlert('고객사 등록시 담당 세무사 코드는 필수 입니다. \n담당 세무사에 문의 하세요.')
    //   return
    // }
    viewLoading("회사 등록 요청 중입니다.");
    requestCompany({
      ...values,
    })
      .then((res) => {
        systemAlert(
          Number(values.type) !== 1 ?
            `${values.name} 파트너 등록이 요청되었습니다. 관리자 승인 후 접속 가능합니다.` :
            `${values.name} 신규 등록되었습니다. 다시 로그인해 주세요.`, {
          buttons: [{
            label: '확인',
            onClick: () => {
              reset();
              history.push("/login");
            }
          }]
        });
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => viewLoading(false));
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
    setValidateFields
  } = useForm({},
    submit,
  );

  useEffect(() => {
    setValidateFields([
      { key: "type", type: 'input', required: true },
      { key: "name", type: 'input', required: true },
      { key: "comNum", type: 'input', required: true, validators: ['comNum'] },
      { key: "ceoName", type: 'input', required: true },
      // { key: "sep", type: 'input', required: true },
      // { key: "rgeNum", type: 'input', required: true, validators: ['jumin'] },
      // { key: "sectNum", type: 'input' },
      { key: "throughTaxCompanyCode", type: 'input' },
      // { key: "incomType", type: 'input', required: true },
    ]);
    const accessPath = getReferrer();

    setForm({
      type: "1",
      name: "",
      comNum: "",
      ceoName: "",
      sep: "0",
      // rgeNum: "",
      // sectNum: "",
      throughTaxCompanyCode: getThroughTaxCompanyCode(),
      // incomType: "1",
      accessPath,
    });
  }, []);

  return (
    <div className="Layout auth-wrap">
      <div className="CreateCompany">
        <h1>신규 기업 등록하기</h1>
        <form>
          <div className="create-company-form">
            <div className="form-info-wrap">
              <label className="form-label">회사타입</label>
              <div className="input-wrap">
                <div className="component-radio-wrap">
                  {COMPANY_TYPE.map(({ label, value }, idx) => (
                    value !== 9 &&
                    <label
                      htmlFor={`company-type-${idx}`}
                      className="data-component-radio-label"
                      key={idx}
                    >
                      <input
                        id={`company-type-${idx}`}
                        className="data-component-radio"
                        type="radio"
                        value={value}
                        name="type"
                        onChange={handleOnChange}
                        checked={idx + 1 === Number(form.type)}
                      />
                      {label}
                    </label>
                  ))}
                </div>
                <p className="error-msg">{errors.type}</p>
              </div>
            </div>
            <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">회사명</label>
              <div className="input-wrap">
                <input
                  className="input"
                  placeholder="회사명을 입력하세요"
                  name="name"
                  value={form.name}
                  onChange={handleOnChange}
                />
                <p className="error-msg">{errors.name}</p>
              </div>
            </div>
            <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">사업자등록번호</label>
              <div className="input-wrap">
                <input
                  className="input"
                  placeholder="사업자등록번호를 입력하세요"
                  name="comNum"
                  value={form.comNum}
                  onChange={handleOnChange}
                />
                <p className="error-msg">{errors.comNum}</p>
              </div>
            </div>
            <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">대표자</label>
              <div className="input-wrap">
                <input
                  className="input"
                  placeholder="대표자명을 입력하세요"
                  name="ceoName"
                  value={form.ceoName}
                  onChange={handleOnChange}
                />

                <p className="error-msg">{errors.ceoName}</p>
              </div>
            </div>
            {/* <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">회사구분</label>
              <div className="input-wrap">
                <div className="component-radio-wrap">
                  {COMPANY_SEP.map(({ label, value }, idx) => (
                    <label
                      htmlFor={`company-sep-${idx}`}
                      className="data-component-radio-label"
                      key={idx}
                    >
                      <input
                        id={`company-sep-${idx}`}
                        className="data-component-radio"
                        type="radio"
                        value={value}
                        name="sep"
                        onChange={handleOnChange}

                        checked={idx === Number(form.sep)}
                      />
                      {label}
                    </label>
                  ))}
                </div>
                <p className="error-msg">{errors.sep}</p>
              </div>
            </div> */}
            {/* <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">
                {"법인등록번호/\n대표자 주민번호"}
              </label>
              <div className="input-wrap">
                <input
                  className="input"
                  placeholder="법인등록번호 혹은 대표자 주민번호를 입력하세요"
                  name="rgeNum"
                  value={form.rgeNum}
                  onChange={handleOnChange}
                />
                <p className="error-msg">{errors.rgeNum}</p>
              </div>
            </div> */}
            {/* <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">종사업자 번호</label>
              <div className="input-wrap">
                <input
                  className="input"
                  placeholder="종사업자 번호를 입력하세요"
                  name="sectNum"
                  value={form.sectNum}
                  onChange={handleOnChange}
                />
                <p className="error-msg">{errors.sectNum}</p>
              </div>
            </div> */}
            {/* <div className="divider" />
            <div className="form-info-wrap">
              <label className="form-label">과면세 구분</label>
              <div className="input-wrap">
                <div className="component-radio-wrap">
                  {INCOM_TYPE.map(({ label, value }, idx) => (
                    <label
                      htmlFor={`incom-type-${idx}`}
                      className="data-component-radio-label"
                      key={idx}
                    >
                      <input
                        id={`incom-type-${idx}`}
                        className="data-component-radio"
                        type="radio"
                        value={value}
                        name="incomType"
                        onChange={handleOnChange}
                        checked={idx + 1 === Number(form.incomType)}
                      />
                      {label}
                    </label>
                  ))}
                </div>
                <p className="error-msg">{errors.incomType}</p>
              </div>
            </div> */}
            <>
              <div className="divider" />
              <div className="form-info-wrap">
                <label className="form-label inline-block">
                  추천 세무사 코드
                  <ToolTip className="" tooltiptext={"추천 세무사 코드를 입력해주세요.\n코드를 전달받지 못하였거나 없다면 공란으로 등록하셔도 됩니다."} />
                </label>
                <div className="input-wrap">
                  <input
                    className="input"
                    placeholder="세무사 코드를 입력하세요"
                    name="throughTaxCompanyCode"
                    value={form.throughTaxCompanyCode}
                    onChange={handleOnChange}
                  />
                  <p className="error-msg">{errors.throughTaxCompanyCode}</p>
                </div>
              </div>
            </>
          </div>
          <Button
            onClick={handleSubmit}
            size="lg"
            type="submit"
            className="mt-24 full-width"
          >
            신규 기업 등록
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RequestCreateCompany;
